module.exports = __webpack_public_path__ + "img/1 (75).20d9cad6.png";